import React, { useEffect, useState } from "react";
import "./Accounts.css";
import { Loader } from "../../Components";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout, passwordReset } from "../../Redux/actions/authActions";
import Navbar_acc from "../../UiComponents/Navbar_acc";
import { toast, ToastContainer } from "react-toastify";
import CustomToast from "../../Components/CustomToast/CustomToast";
import {
  customToatStyle,
  customToatStyleError,
} from "../../Components/CustomToast/CustomToast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Edit_icon } from "../../assets/icons";

export default function AccountSettings({ isAccountOpen, setIsAccountOpen }) {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [activeSection, setActiveSection] = useState("comThree");
  const [reLoading, setReLoading] = useState({ condn: false, label: "" });
  const [showPassword, setShowPassword] = useState(false);

  // toast.success("Success Notification !", {
  //   position: toast.POSITION.TOP_CENTER,
  // });

  const toggleSection = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    await setReLoading({ condn: true, label: "" });
    const res = await dispatch(
      passwordReset(currentPassword, newPassword, confirmPassword)
    );
    if (res?.status) {
      await setReLoading({ condn: false, label: "" });
      toast(
        <CustomToast title="" content={res?.data?.message} />,
        customToatStyle
      );
      setTimeout(() => {
        navigate("/dashboard");
      }, 9000);
    } else {
      await setReLoading({ condn: false, label: "" });
      setTimeout(() => {
        toast(
          <CustomToast
            title=""
            content={res?.response?.data?.message.slice(6)}
          />,
          customToatStyle
        );
      }, 100);
    }
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7  flex justify-center"
      onClick={closeToast}
      style={{ fontStyle: "normal" }}
    >
      ✖
    </i>
  );
  const logoutHandler = () => {
    dispatch(logout(() => navigate("/login")));
  };

  const handleShowPassword = () => {
     setShowPassword(!showPassword);
  }

  return (
    <div className="acc_block ">
      {/* {reLoading?.condn ? <Loader label={reLoading?.label} /> : null} */}

      <ToastContainer closeButton={CloseButton} />
      <div className="NavAcc">
        <Navbar_acc />{" "}
      </div>
      {/* <div className="acc_div2_sub1 ">
          <h1 className="acc_div2_sub1_text1">Account Settings</h1>
        </div> */}
      <div className="acc_div2 drop-shadow-2xl">
        

        <div className="acc_div2_sub2">
          <div className="acc_div2_sub3">
            <div className="acc_div2_block1">
              <div className="acc_div2_sub3_div1">
                <h1 className="text-white">Full Name</h1>
              </div>
              <div className="acc_div2_sub3_div2">
                <h1>
                  {userInfo?.firstName} {userInfo?.lastName}
                </h1>
              </div>
              <div className="acc_div2_sub3_div3">
                {/* <button onClick={() => toggleSection("comOne")}>🖊️</button> */}
              </div>
            </div>
            <div
              className={
                activeSection === "comOne"
                  ? `comOne acc_div2_sub2_div4`
                  : "comOne  hidden "
              }
            >
              <h1 className="text-gray-300 pt-3">Name</h1>
              <div>
                <input
                  className="placeholder_class"
                  placeholder={userInfo?.firstName + " " + userInfo?.lastName}
                  type="text"
                  name="name"
                  readOnly
                />
                <input
                  className="placeholder_class"
                  placeholder="New Name"
                  type="text"
                  name="name"
                />
              </div>
              <div className="flex acc_cancel_div">
                <button className="cancel_btn">Cancel</button>
                <button className="submit_btn">Submit</button>
              </div>
            </div>
          </div>

          <div className="acc_div2_sub3">
            <div className="acc_div2_block1">
              <div className="acc_div2_sub3_div1">
                <h1>E-mail</h1>
              </div>
              <div className="acc_div2_sub3_div2">
                <h1 >{userInfo?.email}</h1>
              </div>
              <div className="acc_div2_sub3_div3">
                {/* <button onClick={() => toggleSection("comTwo")}>🖊️</button> */}
              </div>
            </div>
            <div
              className={
                activeSection === "comTwo"
                  ? `comTwo    acc_div2_sub2_div5`
                  : "comTwo hidden"
              }
            >
              <div>
                <input
                  className="placeholder_class"
                  placeholder={userInfo?.email}
                  type="text"
                  name="name"
                  readOnly
                />
                <input
                  className="placeholder_class"
                  placeholder="New E-mail address"
                  type="text"
                  name="name"
                />
              </div>

              <div className="flex acc_cancel_div">
                <button className="cancel_btn">Cancel</button>
                <button className="submit_btn">Submit</button>
              </div>
            </div>
          </div>

          <div className="acc_div2_sub3">
            <div className="acc_div2_block1">
              <div className="acc_div2_sub3_div1">
                <h1>Password</h1>
              </div>
              <div className="acc_div2_sub3_div2">
                <h1 className="text-2xl pt-[3px]">**********</h1>
              </div>
              <div className="acc_div2_sub3_div3">
                <button onClick={() => toggleSection("comThree")}>
                  <img className="w-5" src={Edit_icon} alt="icon" />
                </button>
              </div>
            </div>
            <div
              className={
                activeSection === "comThree"
                  ? `comThree  acc_div2_sub2_div6`
                  : "comThree hidden"
              }
            >
              <div className=""
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="manrope-600 w-[50%]">Current Password</label>
                <div className="flex justify-end items-center w-full">
                  <input
                    className="custom_placeholder_class"
                    placeholder="current password"
                    type={showPassword ? "text" : "password"}
                    name="currentpassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <div onClick={handleShowPassword} className="absolute top-[4rem] mr-4 w-5 h-5 text-white cursor-pointer">
                    {showPassword ? <FaEye/> : <FaEyeSlash/>}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="W-[30%]">New Password</label>
                <input
                  className="placeholder_class"
                  placeholder="new password"
                  type="text"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="W-[30%]">Confirm New Password</label>

                <input
                  className="placeholder_class"
                  placeholder="confirm new password"
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <div className="acc_cancel_div">
              <button className="submit_btn" onClick={submitHandler}>
                  Update Password
                </button>
                <button
                  className="cancel_btn"
                  onClick={() => navigate("/dashboard")}
                >
                  Cancel
                </button>
                
              </div>
            </div>
          </div>
        </div>

        {/* <div className="logout_block"><div className="cursor-pointer" onClick={logoutHandler}>Logout</div></div> */}
      </div>
    </div>
  );
}
